import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload2--sprite",
  "use": "upload2--sprite-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"upload2--sprite\">\n<path d=\"M9.33333 7.33333V9.33333H1.33333V7.33333H0V9.33333C0 10.0667 0.6 10.6667 1.33333 10.6667H9.33333C10.0667 10.6667 10.6667 10.0667 10.6667 9.33333V7.33333H9.33333ZM2 3.33333L2.94 4.27333L4.66667 2.55333V8H6V2.55333L7.72667 4.27333L8.66667 3.33333L5.33333 0L2 3.33333Z\" fill=\"#333333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol